import { Component, Inject, Injector, Input, OnInit, OnDestroy } from '@angular/core';
import { GlobalObjectsService } from '../../shared/services/global-objects.service';
import { Product } from '../../shared/models/product.model';
import { NotificationService } from '../services/notification.service';
import { UiconfigrationService } from 'src/app/core/services/uiconfigration.service';
import { UIConfigurationType } from 'src/app/shared/models/uiconfigration.interface';
import { BootstrapRequestContext } from 'tbs-typings';
import { CommonService } from 'src/app/core/services/common.service';
import { take, takeUntil } from 'rxjs/operators';
import { TBSBaseComponent } from 'src/app/shared/models/tbsBaseComponent';
import { ChildComponentOptions } from 'src/app/shared/models/childComponentOptions.model';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  standalone: false
})
export class FooterComponent extends TBSBaseComponent implements OnInit, OnDestroy {
  products: Product[];
  @Input() FooterStyleSwitch: boolean;
  baseUrl: string;
  uiConfig: UIConfigurationType;
  enableOneTrust = false;
  enableOneTrustOptionalCookies = false;
  privacyPolicyUrl: string;
  PRIVACY_POLICY_ROUTING_URL: string = "/home/privacy-policy";

  constructor(
    @Inject('BootstrapRequestContext') private readonly bootstrapRequestContext: BootstrapRequestContext,
    private readonly injector: Injector,
    private readonly globalojectService: GlobalObjectsService,
    private readonly notificationService: NotificationService,
    private readonly commonService: CommonService,
    private readonly uiconfigrationService: UiconfigrationService) {
    super(injector, new ChildComponentOptions(true, false, true));
    this.addResourceStringKeys(this.resService.footerStringKeys);
    this.enableOneTrust = bootstrapRequestContext.enableOneTrust;
    this.enableOneTrustOptionalCookies = bootstrapRequestContext.enableOneTrustOptionalCookies;
  }

  ngOnInit(): void {
    this.privacyPolicyUrl = this.helperService.getPrivacyPolicyUrl();
    if (this.privacyPolicyUrl.includes(window.location.origin)) {
      this.privacyPolicyUrl = this.PRIVACY_POLICY_ROUTING_URL;
    }
    this.globalojectService.checkHeaderFooterConfig
      .pipe(takeUntil(this.unsubscribe))
      .subscribe(value => {
        if (value) {
          this.baseUrl = this.helperService.getBaseUrl();
          this.uiConfig = this.uiconfigrationService.getUIConfiguration();
          if (!sessionStorage.getItem('uiConfigGuest')) {
            this.uiconfigrationService.getDefaultUIConfigrationFromService()
              .pipe(take(1))
              .subscribe(du => {
                if (du) {
                  sessionStorage.setItem('uiConfigGuest', JSON.stringify(du));
                }
              });
          }
          if (!this.uiConfig.uiConfiguration.hideProducts) {
            this.globalojectService.Products
              .pipe(takeUntil(this.unsubscribe))
              .subscribe(r => {
                this.products = this.commonService.getUniqueProductsFromProductList(r);
              });
          }
          this.refreshResourceStrings();
          this.notificationService.getMessage()
            .pipe(takeUntil(this.unsubscribe))
            .subscribe(() => {
              this.getCurrentPathRoleSettingStatus(this.injector);
              this.refreshResourceStrings();
            });
        }
      });
  }

  private refreshResourceStrings(): void {
    this.loadResourceStringAsObservable()
      .pipe(takeUntil(this.unsubscribe))
      .subscribe(res => this.getResouceStringsAsObject(res));
  }

  showLightFooter(): boolean {
    //When showLightFooter enabled, if standard footer is enabled we'll switch to the skinny footer while within a flow.
    this.helperService.setMainContentMinHeight();
    if (this.uiConfig.uiConfiguration?.showLightFooter) {
      return this.isFlowContext();
    }
    return false;
  }

  private isFlowContext(): boolean {
    return this.helperService.isQuoteRoute() || this.helperService.isBenefitRoute() || this.helperService.isClaimRoute();
  }

  ngOnDestroy(): void {
    this.signalUnsubscribe();
  }

  footerClick(eventArg) {
    let clickedTagName = eventArg?.target?.tagName;
    if (clickedTagName == 'A') {
      this.analyticsService.trackHeapEvent("General", "Footer - Click - Link", clickedTagName.innerText);
    }
  }
}
